import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "是否異常",
    isNumber: true,
  },
];

export const Pie = {
  label: "各項需追蹤人數_圓餅圖",
  key: "Pie",
  path: "HealthAnalysisManagement/Pie",
  api: "TCS_V_EyesS01",
  render: (options) => <Diagram.HealthAnalysisManagement.Pie {...options} />,
  filter: {
    key: "種類",
    value: "高血脂",
  },
  isGroup: true,
  groupColumns: [
    {
      key: "是否異常",
      field: "是否異常",
      header: "",
    },
  ],
  filterColumns: [{ key: "創建日期", type: "date" }],
  levelColumns,
  columns: [],
  exportColumns: [
    {
      key: "是否異常",
      label: "是否異常",
    },
  ],
};
